export const parseLocaleForFluidConfigure = (lang: string, country: string) => {
  // For India Fluid Configure does not accept en_IN as locale, instead en_GB are accepted.
  const locale = `${lang}_${country.toLocaleUpperCase()}`;
  const parsedLocale = locale === 'en_IN' ? 'en_GB' : locale;

  return { locale: parsedLocale };
};
